import { normalizeThreadAttachments } from '../../utils/campaignThreadAttachment';
import type { ICampaignThreadMessage } from './campaignThreadMessage.types';
import type { ICampaignWorkspaceUserStub, IWorkspaceMessage } from './campaignWorkspace.types';

export function threadMessageToWorkspaceMessage(m: ICampaignThreadMessage): IWorkspaceMessage {
    const raw = m.sender;
    const sender: ICampaignWorkspaceUserStub & { display_name?: string | null } =
        typeof raw === 'object' && raw !== null && '_id' in raw
            ? {
                  _id: raw._id,
                  firstName: raw.firstName,
                  lastName: raw.lastName,
                  userName: raw.userName,
                  profile_picture: raw.profile_picture,
                  role: raw.role,
                  display_name: raw.display_name,
              }
            : { _id: String(raw) };

    return {
        _id: m._id,
        content: m.content,
        attachments: normalizeThreadAttachments(m.attachments as unknown[] | undefined),
        read: m.read,
        visibility: m.visibility,
        message_type: m.message_type,
        createdAt: m.createdAt,
        updatedAt: m.updatedAt,
        sender,
    };
}
